import type { ReactNode } from "react";
import { cx } from "../cx.ts";

export interface EmptyStateProps {
  icon?: ReactNode;
  title: string;
  children?: ReactNode;
  action?: ReactNode;
  className?: string;
}

/** What a list shows when it has nothing in it, with the next step to take. */
export function EmptyState({ icon, title, children, action, className }: EmptyStateProps) {
  return (
    <div
      className={cx(
        "flex flex-col items-center gap-2 rounded-xl border border-line border-dashed px-6 py-10 text-center",
        "sun:border-2 sun:border-black sun:border-solid",
        className,
      )}
    >
      {icon ? (
        <div aria-hidden className="mb-1 text-ink-muted [&_svg]:size-8">
          {icon}
        </div>
      ) : null}
      <p className="font-semibold text-ink">{title}</p>
      {children ? <div className="max-w-md text-ink-muted text-sm">{children}</div> : null}
      {action ? <div className="mt-3">{action}</div> : null}
    </div>
  );
}
